import script from "./ItemDetailEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemDetailEditor.vue?vue&type=script&setup=true&lang=js"

import "./ItemDetailEditor.vue?vue&type=style&index=0&id=5cd2bd1e&scoped=true&lang=css"

import exportComponent from "/app/inventory-ui-actions-runner/_work/inventory-ui/inventory-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd2bd1e"]])

export default __exports__